module.exports = __webpack_public_path__ + "img/发展历程.2faa9a3a.png";